<script lang="ts">
  import { Col, Container,  Row } from "sveltestrap";
  import BookmarkWhetherIcon from "./BookmarkWhetherIcon.svelte";
  import Card from "../../Core/Card.svelte";
  import {  WeatherIconsWithAnimations } from "../../../utils/Constant/Constant";
  import * as SvgIcon from "../../../Data/IconsData/WeatherIcons"
  import data from "../../../Data/IconsData/WeatherSvg.json"
  import WhetherIconBottom from "./WhetherIconBottom.svelte";
  import {iTag,icons,iconClick} from "../../../store"
  function getItag(tag:any) {
    iTag.update(value => value = tag);
    icons.update(value=> value = tag) ;
    iconClick.update(value => value = true);
  }
</script>
<BookmarkWhetherIcon />
<Container fluid>
    <Row>
        <Col sm="12">
            <Card headerTitle={WeatherIconsWithAnimations} cardHeaderprops="pb-0">
                <div slot="contentbody">
                    <Row class="icon-lists whether-icon">
                        {#each data as item}
                            <Col lg="2" xs="3" >
                                <!-- svelte-ignore a11y-click-events-have-key-events -->
                                <span on:click={() => getItag(SvgIcon[item.svg])}>
                                    {@html SvgIcon[item.svg]}
                                </span>
                            </Col>
                        {/each}
                    </Row>
                </div>
            </Card>
        </Col>
    </Row>
</Container>
<WhetherIconBottom />
